module.exports = __webpack_public_path__ + "img/superlever-cardIcon2.d9a3c2f5.svg";